<template>
  <div>
    <div id="skipToContent">
      <a href="#contents">콘텐츠 바로가기 </a>
    </div>

    <!-- main -->
    <main>
      <DashboardHeader/>
      <!-- contents -->
      <div class="abo-dashboard">
        <DashboardContentsCalendar
            @prev="prevMonth"
            @next="nextMonth"
            :attainment="attainment"/>

        <div class="main-dash_section">
          <DashboardContentsAttainment
            @layer="showLayerAttinment"
            :attainmentlevel="attainment.level"
            :attainmentmonth="attainment.month"/>

          <DashboardContentsAbocardList
            @layer="showLayerOrderList"
            :abocardlist="aboCardList"
            :deadline="deadline"/>
        </div>

        <DashboardLayerAttainmentMessage
            :attainmentmonth="attainment.month"/>
      </div>
    </main>
    <!-- //main -->

    <DashboardLayerAttainment
      @layer="closeLayer"/>

    <DashboardLayerAboOrderHistory
      @layer="closeLayer"
      :orderinfo="aboOrderInfo"
      :orderlist="aboOrderList"/>
  </div>
</template>

<script>
// Component
import DashboardHeader from './component/header.vue' // 상단-헤더
import DashboardContentsCalendar from './component/calendar.vue' // 달성정보-달력
import DashboardContentsAttainment from './component/attainment.vue' // 달성정보-그래프(메인)
import DashboardContentsAbocardList from './component/abocardList.vue' // 구성원-목록
import DashboardLayerAttainment from './component/layerAttainment.vue' // layer-달성조건보기layer
import DashboardLayerAboOrderHistory from './component/layerAboOrderHistory.vue' // layer-주문내역
import DashboardLayerAttainmentMessage from './component/layerAttainmentMessage.vue' // layer-목표달성

// Library
import Vue from 'vue'
import axios from 'axios'
import $ from 'jquery'
import VueConfetti from 'vue-confetti'

Vue.use(VueConfetti)

export default {
  name: 'salesDashboard',
  components: {
    DashboardHeader,
    DashboardContentsCalendar,
    DashboardContentsAttainment,
    DashboardContentsAbocardList,
    DashboardLayerAttainmentMessage,
    DashboardLayerAttainment,
    DashboardLayerAboOrderHistory
  },
  data () {
    return {
      aboInfo: Object,
      attainment: Object({year: String('2021'), month: String('03'), level: Number(0), persent: Number(0)}),
      aboCardList: Object,
      aboOrderList: Object,
      aboOrderInfo: Object,
      ready: false,
      effect_flag: String,
      deadline: String
    }
  },
  methods: {
    init: async function () { // 초기화
      this.aboInfo = {aboNo: '', aboName: ''}
      this.orderinfo = {name: '', count: 0, agree: ''}
      this.attainment = {}
      this.aboCardList = []
      this.aboOrderInfo = {}
      this.effect_flag = 'N',
      this.deadline = 'Y'

      // 날짜 설정
      let dt = new Date()
      dt.setDate(dt.getDate()-1) // -1 일 처리
      this.attainment = {year: String(dt.getFullYear()), month: this.padding(String(dt.getMonth() + 1), 2, '0'), level: 0, persent: 0}

      await this.checkLogin() // 로그인 체크(회원번호,이름)
      await this.reset()
    },
    // 로그인 체크
    checkLogin: async function () {
      await axios.get(process.env.OCC_ROOT_URL + '/sso/authorizeEvent', {withCredentials: true}
      ).then(response => {
        if (response.data.header.status === 'ERROR') { // login fail
          window.location.href = process.env.AMWAY_ROOT_URL + '/login'
        } else if (response.data.customerUid != null && response.data.customerUid !== 'none') {
          // login success
          this.aboInfo.aboNo = atob(response.data.customerUid)
          this.aboInfo.aboName = response.data.name
        }
      }).catch(ex => {
        window.location.href = process.env.AMWAY_ROOT_URL + '/login'
      })
    },
    showLayerAttinment: function (layerId) {
      var targetLayer = document.querySelector('#' + layerId)
      targetLayer.classList.add('showing')
      $('html, body').addClass('scroll-off')
    },
    showLayerOrderList: async function (layerId, aboNo, name, privacy) {
      this.aboOrderInfo = {'aboNo': aboNo, 'name': name, 'privacy': privacy}
      await this.loadAboOrderList()
      var targetLayer = document.querySelector('#' + layerId)
      targetLayer.classList.add('showing')
      $('html, body').addClass('scroll-off')
    },
    closeLayer: function () {
      let layers = document.querySelectorAll('.layer-area')
      $(layers).removeClass('showing')
      $('html, body').removeClass('scroll-off')
    },
    prevMonth: async function () {
      let numberMonth = Number(this.attainment.month)
      if (numberMonth === 3) {
        return false
      } else {
        this.attainment.month = this.padding(numberMonth - 1, 2, '0')
        await this.reset()
      }
    },
    nextMonth: async function () {
      let numberMonth = Number(this.attainment.month)
      if (this.attainment.month === 5) {
        return false
      } else {
        this.attainment.month = this.padding(numberMonth + 1, 2, '0')
        await this.reset()
      }
    },
    padding: function (str, len, pad) {
      let r = ''
      for (var i = String(str).length; i < len; i++) {
        r += pad
      }
      r += str
      return r
    },
    reset: async function () {
      await this.loadAttainment() // api 조회
      this.attainmentGrahp() // 목표달성 그래프
      this.attainmentEffect() // 목표달성 효과
      this.aboCardEffect() // abo 목록 효과
    },
    attainmentEffect () {
      // TODO :: 목표달성 여부 체크
      if (this.attainment.level < 10) {
        $('.abo-dimmed').fadeOut()
      } else {
        if ( this.effect_flag === 'Y') {
          $('.abo-dimmed').show()
          this.$confetti.start({
            particles: [{type: 'rect'}],
            defaultColors: ['DodgerBlue', 'OliveDrab', 'Gold', 'pink', 'SlateBlue', 'lightblue', 'Violet', 'PaleGreen', 'SteelBlue', 'SandyBrown', 'Chocolate', 'Crimson']
          })

          setTimeout(() => {
            this.loadEffectSave()
          }, 2000)
        }
      }
    },
    attainmentGrahp () {
      // Dashboard 의 % 계산
      var segments = $('.chart-segment')
      var firstSegmentOffset = parseInt($(segments[0]).attr('stroke-dashoffset'))
      var preSegmentsTotalLength = this.attainment.persent

      for (var i = 0; i < segments.length; i++) {
        var progress = this.attainment.persent
        var radian = 2 * Math.PI * $(segments[i]).attr('r')

        progress = progress / 100
        progress = radian * (1 - progress)

        $(segments[i]).css({
          'strokeDasharray': radian,
          'strokeDashoffset': progress
          // radian
        })
        if (i !== 0) {
          var strokeDashoffset = 100 - preSegmentsTotalLength + firstSegmentOffset
          $(segments[i]).css('stroke-dashoffset', strokeDashoffset)
          preSegmentsTotalLength += this.attainment.persent
        }
      }
    },
    aboCardEffect: function () {
      // 누적 구매금액 애니메이션
      var posY
      var graphTarget = document.querySelectorAll('.card-inner')
      for (var i = 0; i < graphTarget.length; i++) {
        posY = graphTarget[i].getBoundingClientRect().top
        if (posY < (window.innerHeight * 0.98)) {
          graphTarget[i].classList.add('moving')
        }
      }
    },
    loadEffectSave: async function () {
      this.aboOrderList = []
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/sales/dashboard-effect',
        {
          month: this.attainment.year + this.attainment.month,
          abo_no: this.aboInfo.aboNo
        }).then(response => {

        this.$confetti.stop()
        this.$confetti.remove()
        $('.abo-dimmed').fadeOut()

        if (response.status === 200) {
          console.log('Amway Event LOG : Effect Off', response.data.statusMessage)
        } else {
          alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    },
    loadAboOrderList: async function () {
      this.aboOrderList = []
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/sales/dashboard',
        {
          month: this.attainment.year + this.attainment.month,
          abo_no: this.aboInfo.aboNo,
          ord_abo_no: this.aboOrderInfo.aboNo,
          type: 'order'
        }).then(response => {
        if (response.status === 200) {
          response.data.order.data.forEach(item => { // ABO 목록 설정
            this.aboOrderList.push({'number': item.ORD_NO, 'date': item.ORD_DT.formatDate(), 'amt': item.ORD_AMT.formatWon()})
          })
        } else {
          alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    },
    loadAttainment: async function () {
      this.aboCardList = []
      await axios.post(
        process.env.AWS_GATEWAY_URL_V2 + '/sales/dashboard',
        {
          month: this.attainment.year + this.attainment.month,
          abo_no: this.aboInfo.aboNo,
          type: 'abo'
        }).then(response => {
        if (response.status === 200) {
          let attainmentCnt = (response.data.achive.data ? response.data.achive.data : 0) // 목표달성 조(Default 0) 지역변수
          this.attainment.level = attainmentCnt // 목표달성 조 설정
          this.attainment.persent = (attainmentCnt * 10 > 100 ? 100 : attainmentCnt * 10) // 목표달성 조 퍼센트
          this.deadline = (response.data.closed.data === 'N'? 'N' : "Y")
          this.effect_flag = (response.data.effect.data === 'N'? 'N' : "Y")
          if (response.data.abo.length === 0) return

          response.data.abo.data.forEach(item => { // ABO 목록 설정
            let limit = 100000
            let persent = Math.floor(item.ORD_AMT / limit > 100 ? 100 : item.ORD_AMT / limit * 100) // ABO 목표금액 퍼센트
            this.aboCardList.push({'number': item.ORD_IMC_NO, 'number_mask': item.ORD_IMC_NO.maskabo(), 'name': item.ORD_IMC_NM, 'amt': item.ORD_AMT.formatWon(), 'persent': persent, 'privacy': item.PRIVACY_CD})
          })
        } else {
          alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
        }
      }).catch(error => {
        console.log('error : ', error)
        alert('죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.')
      })
    }
  },
  mounted: function () {
    window.setTimeout(() => {
      this.ready = true
      this.init()
    }, 500)
  },
  created: function () {
    window.addEventListener('scroll', this.aboCardEffect)

    // 원화 포맷(number)
    Number.prototype.formatWon = function() {
      if(this==0) return 0
      var reg = /(^[+-]?\d+)(\d{3})/
      var n = (this + '');
      while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2')
      return n
    }

    // 원화 포맷(string)
    String.prototype.formatWon = function() {
      var num = parseFloat(this)
      if( isNaN(num) ) return "0"
      return num.formatWon()
    }

    // 날짜형태 포맷
    String.prototype.formatDate = function() {
      var num = this.substring(0,4) + '-' + this.substring(4,6) + '-' + this.substring(6,8)
      if( !isNaN(num) ) return this
      return num
    }

    // 이름 마스킹
    String.prototype.maskname = function() {
      let limit = 1
      var len = this.length
      var num = this.substring(0,limit) + this.substring(limit,len).replace(/\W/gi, "*")
      if( !isNaN(num) ) return this
      return num
    }

    // abo번호 마스킹
    String.prototype.maskabo = function() {
      let limit = 4
      var len = this.length
      var num = this.substring(0,limit) + this.substring(limit,len).replace(/\d/gi, "*")
      if( !isNaN(num) ) return this
      return num
    }
  }
}
</script>

<style scoped>
@import './assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard/dashboard.vue